/**
* @file 登录页面
*/
<template>
  <div v-loading="isLoading" class="p-login">
    <div class="p-login-card">
      <div class="p-login-card__desc">
        <div
          :style="{
            backgroundImage: `url(${customLogo})`,
            backgroundRepeat: 'no-repeat',
          }"
          class="p-login-card__desc__logo"
        ></div>
        <div class="p-login-card__desc__welcome">
          欢迎登录集团账号管理后台
        </div>
      </div>
      <div
        v-if="currentFormType === formEnum.LOGIN"
        key="login"
        class="p-login-form"
        @keydown.enter="handleSubmit"
      >
        <plv-form
          ref="loginForm"
          :model="form"
          :rules="rules"
        >
          <plv-form-item
            prop="email"
            required
          >
            <plv-input
              v-model="form.email"
              placeholder="请输入电子邮箱"
              prefix-icon="user"
            />
          </plv-form-item>
          <plv-form-item
            prop="password"
            required
          >
            <plv-input
              v-model="form.password"
              placeholder="请输入密码"
              prefix-icon="lock"
              type="password"
            />
          </plv-form-item>
          <div class="p-login-form__other">
            <plv-checkbox v-model="rememberMe" label="记住账号" />
            <span class="p-link-btn" @click="handleFormChange(formEnum.RE_PASSWORD)">忘记密码</span>
          </div>
          <div class="p-login-form__privacy">
            登录前请仔细阅读
            <a href="https://www.polyv.net/agreement/" target="_blank">《服务协议》</a>
            及
            <a href="https://www.polyv.net/policy/" target="_blank">《隐私政策》</a>
          </div>
          <plv-form-item>
            <plv-button @click="handleSubmit">同意并登录</plv-button>
          </plv-form-item>
        </plv-form>
      </div>
      <div v-else-if="currentFormType === formEnum.RE_PASSWORD" key="rePassword" class="p-re-password-form">
        <plv-form
          ref="rePasswordForm"
          :model="rePasswordForm"
          :rules="rules"
        >
          <plv-form-item
            prop="email"
            required
          >
            <plv-input
              v-model="rePasswordForm.email"
              prefix-icon="user"
              placeholder="请输入电子邮箱"
            />
          </plv-form-item>
          <plv-form-item>
            <plv-slide-verify v-model="verifyValue" @success="onVerifySuccess" />
          </plv-form-item>
          <plv-form-item>
            <plv-button @click="handleResetPassword">发送密码重置邮件</plv-button>
          </plv-form-item>
        </plv-form>
        <p class="p-to-login">已有帐号，<span class="p-link-btn" @click="handleFormChange(formEnum.LOGIN)">马上登录</span></p>
      </div>

      <div v-else-if="currentFormType === formEnum.SEND_SUCCESS" class="p-re-success-form">
        <div class="p-re-success-header">
          <plv-icon
            class="p-re-message"
            icon="message"
          />
          <span>密码重置邮件发送成功</span>
        </div>
        <div class="p-re-success-body">{{ `邮件已发送至您的注册邮箱：${rePasswordForm.email}请查收邮件。` }}</div>
        <plv-button @click="handleFormChange(formEnum.LOGIN)">返回登录</plv-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { local } from '@polyv/utils/storage';
import { objectToFormData } from '@/utils/utils';
import { formEnum } from '@/views/login/constant';

const defaultLogo = require('../../assets/images/logo.png');

export default {
  data() {
    return {
      currentFormType: formEnum.LOGIN,
      formEnum,
      isLoading: false,
      form: {
        email: '',
        password: '',
      },
      rePasswordForm: {
        email: '',
      },
      verifyValue: undefined,
      rememberMe: false, // 记住账号
      rules: {
        email: [
          {
            type: 'string',
            message: '请输入邮箱',
            required: true,
          },
          {
            type: 'email',
            message: '请输入正确的邮箱格式',
          },
        ],
        password: [
          {
            type: 'string',
            message: '请输入密码',
            required: true,
          },
        ],
      },
      isSlideVerify: false
    };
  },
  computed: {
    ...mapState({
      customInfo: (state) => state.account.customInfo,
    }),
    customLogo() {
      const {
        customLoginLogo,
        customBrandEnabled,
      } = this.customInfo ?? {};
      return this.ynToBool(customBrandEnabled || 'N') && customLoginLogo ? customLoginLogo : defaultLogo;
    },
  },
  created() {
    const localAccountForm = local.getAsJSON('accountForm');
    if (localAccountForm) {
      this.form = localAccountForm;
      this.rememberMe = true;
    }
  },
  methods: {
    ...mapActions({
      login: 'account/login',
    }),
    async handleSubmit() {
      try {
        await this.$refs.loginForm.validate();
        const res = await this.login(this.form);
        const { authToken } = res;
        this.$store.commit('common/setXAuthToken', authToken);
        if (this.rememberMe) {
          local.setAsJSON('accountForm', this.form);
        } else {
          local.remove('accountForm');
        }
        const billDictionary = await this.$store.dispatch('account/getBillDictionary');
        this.$store.commit('account/setBillDictionary', billDictionary);
        const customConfig = await this.$store.dispatch('account/getGroupCustom', {
          domain: window.location.host,
        });
        this.$store.commit('account/setCustomInfo', customConfig);
        this.$router.push('/group');
      } catch {
      }
    },
    async onVerifySuccess() {
      this.isSlideVerify = true;
    },
    handleFormChange(form) {
      this.isSlideVerify = false;
      this.currentFormType = form;
    },
    async forgetFormSubmit(form) {
      try {
        this.isLoading = true;
        await this.$store.dispatch('account/forgetPassword', objectToFormData({
          email: form.email,
          ...this.verifyValue,
        }));
        this.currentFormType = formEnum.SEND_SUCCESS;
      } finally {
        this.isLoading = false;
      }
    },
    async handleResetPassword() {
      await this.$refs.rePasswordForm.validate();
      if (!this.isSlideVerify) {
        this.$toast.error('请滑动滑块');
        return;
      }
      await this.forgetFormSubmit(this.rePasswordForm);
    },
  },
};
</script>

<style lang="scss">
.p-login {
  min-width: 1170px;
  height: 100%;
  background: url('../../assets/images/login_bg.png') no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;

  .p-login-card {
    width: 480px;
    height: 480px;
    background: #fff;
    border-radius: 4px;

    &__desc {
      width: 100%;
      padding: 38px 0;

      &__logo {
        width: 200px;
        height: 42px;
        background: url('../../assets/images/logo.png') no-repeat;
        background-size: contain;
        margin: 0 auto;
      }

      &__welcome {
        font-size: 16px;
        text-align: center;
        margin-top: 20px;
      }
    }

    .p-login-form, .p-re-password-form {
      padding: 30px 91px 40px 91px;
      margin: 0 auto;

      .plv-admin-icon-lock {
        font-size: 18px !important;
      }

      .plv-button {
        width: 100%;
      }

      &__other {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
      }

      &__privacy {
        font-size: 14px;
        color: #757575;
        margin-bottom: 8px;
        display: flex;
        align-items: center;

        a {
          color: #246AF4;
          text-decoration: none;
        }
      }
    }

    .p-re-success-form {
      padding: 30px 40px 40px 40px;
      margin: 0 auto;
      .p-re-success-header {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 25px;
        color: #2196f3;
        margin-bottom: 25px;
        .p-re-message {
          font-size: 40px;
        }
      }

      .p-re-success-body {
        text-align: center;
        line-height: 20px;
        margin-bottom: 30px;
      }
      .plv-button {
        width: 100%;
        height: 40px;
      }
    }

    .p-to-login {
      margin-top: 20px;
      text-align: center;
    }

    .p-link-btn {
      color: #333;
      cursor: pointer;

      &:hover {
        color: #2196f3;
      }
      &:active {
        opacity: .6;
      }
    }
  }
}
</style>
